export const INPOST_PHONE_NUMBER_CSS_CLASSES: Record<string, string> = {
    deliveryInactive: 'delivery_inactive'
};

export const INPOST_ENGINE = 'inpost';
